'use client';

import React from 'react';
import { Tooltip } from 'antd';
import { FiCopy } from 'react-icons/fi';
import ThemedButton from '@/components/common/buttons/Button';
import { copyToClipboard } from '../utils';

interface InfoBlockProps {
  label: string;
  value: React.ReactNode;
  copyValue?: string | null;
  className?: string;
}

const InfoBlock = ({ label, value, copyValue, className }: InfoBlockProps) => (
  <div
    className={className}
    style={{
      borderBottom: '1px solid var(--color-primary)',
      padding: '12px 0',
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      minWidth: 0,
    }}
  >
    <span
      style={{
        fontSize: 10,
        fontWeight: 800,
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
      }}
    >
      {label}
    </span>

    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
      <div
        style={{
          fontSize: 14,
          fontWeight: 500,
          flex: 1,
          wordBreak: 'break-word',
          lineHeight: 1.6,
        }}
      >
        {value || '—'}
      </div>

      {copyValue && (
        <Tooltip title={`Copy ${label}`}>
          <ThemedButton
            size="small"
            variant="outlined"
            theme="secondary"
            text=""
            icon={<FiCopy size={12} />}
            onClick={() => copyToClipboard(label, copyValue)}
          />
        </Tooltip>
      )}
    </div>
  </div>
);

export default InfoBlock;
